module.exports = __webpack_public_path__ + "wxMicroService/img/401.089007e7.gif";